import * as React from "react";
const SvgIconCheckboxUnchecked = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 15, height: 15, stroke: "#19A1B7" }));
export default SvgIconCheckboxUnchecked;
